// Complete scraped static data for Dansk Tagbyg ApS

export const COMPANY_INFO = {
  name: "Dansk Tagbyg ApS",
  cvr: "37445991",
  phone: "28 68 74 50",
  phoneFormatted: "28 68 74 50",
  phoneTel: "tel:28687450",
  email: "kontakt@dansktagbyg.dk",
  emailMailto: "mailto:kontakt@dansktagbyg.dk",
  address: "Schødtsmindevej 22, bygning 3, 8464 Galten",
  city: "Galten",
  zip: "8464",
  street: "Schødtsmindevej 22, bygning 3",
  owner: "Lasse Vesterhouen",
  established: "2016",
  rating: "4.8",
  reviewCount: "155",
  ratingLink: "https://www.anmeld-haandvaerker.dk/tagdaekker/dansk-tagbyg-aps"
};

export const SERVICES = [
  {
    id: "tegltag",
    slug: "tegltag",
    title: "Tegltag",
    category: "Nyt tag",
    description: "Dansk Tagbyg leverer de bedste tagløsninger. Vi er specialister i tagdækning, nyt tag, tegltag og isolering.",
    meta_title: "Dansk Tagbyg – Eksperter i tegltag – din tagdækker i hele Danmark - Dansk Tagbyg",
    meta_description: "Dansk Tagbyg leverer de bedste tagløsninger. Vi er specialister i tagdækning, nyt tag, tegltag og isolering.",
    image: "https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/scraped-1_a9ee376f.webp",
    content: `Tagsten i ægte tegl af hårdtbrændt ler er en klassisk og velkendt løsning, som byer på mange muligheder i forhold til blandt andet farver og glasur. Et tegltag er en økonomisk investering i dit hus, da det har en levetid på over 100 år. Tegltag får en smuk patina med årene, dog uden at falme.

Et tegltag er en miljøbevidst beslutning, da der ikke benyttes tilsætningsstoffer og bindemidler. Det er desuden en storm- og brandsikker løsning, som i øvrigt er dansk produceret højkvalitet.

## Tegltag - tag med lang holdbarhed

At give din bolig nyt tag er det ultimative ansigtsløft. Her er tegltag et af danskernes foretrukne valg af tag. Både teglets smukke udseende og lange holdbarhed gør tegltaget til den mest udbredte tagtype i Danmark. Tegltag er et holdbart naturprodukt.

Tegl er en blanding af vand og jord, hvilket efter den rigtige forarbejdning bliver til en af de mest holdbare tagløsninger på markedet. Tegltag er en type tag, der har en høj holdbarhed og modstår både regn, sne, slud eller blæst. Teglsten er desuden en type tag, der er farvet med naturfarver og derfor falmer tegltag heller ikke med tiden pga. årstidernes skiften og slid, hvilket andre typer af tagsten ofte gør.

Da teglsten brændes ved meget høj varme, er de også meget holdbare. Det giver dig et tag, som du kan forvente holder mellem 50-70 år.

## Tegltag med mange udtryk

Når det kommer til at vælge et tegltag, er der flere forskellige muligheder at vælge imellem. Grunden til dette er, at teglsten laves i flere forskellige farver, størrelser og former samt med forskellige overfladebehandlinger af teglen, så den fremstår mat eller blank. Det betyder, at du helt sikkert også kan få et tegltag, der passer i stilen til din bolig.

Når du gerne vil kende prisen på et nyt tegltag til din bolig, er der flere forskellige faktorer, der spiller ind. Det gælder fx taghældning, tagets kompleksitet i form af ovenlysvinduer, skorsten, kviste mv., undertagets stand og om det også skal udskiftes, nødvendigt tillægsudstyr og muligheden for at genbruge tagsten. Ring til os og få et uforpligtende tilbud, så du har en fornemmelse af, hvor det ligger henne prismæssigt.

## Miljøbevidst valg med lang levetid

Tegltag indeholder ingen tilsætningsstoffer eller bindemidler, og derfor er tegltag et miljøbevidst valg, da denne teglsten er mildere for miljøet end andre typer tagsten.

Samtidig kræver tegltagsten meget lidt vedligeholdelse, bl.a. fordi at teglsten brændes ved meget høj varme. Da teglsten er en yderst holdbar og stærk type tagsten betyder det også, at teglsten har en lang levetid, hvilket er på mere end 50 år i de fleste tilfælde.

### Fordele ved tegltag:

- Høj kvalitet og lang levetid på 50-70 år
- Dansk produceret
- Miljøbevidst valg af tag
- Mange forskellige farver, former og overflader
- Naturprodukt med meget lidt vedligeholdelse
- Storm- og brandsikkert
- Beskytter mod vejr og vind

## Professionel rådgivning og vejledning hos Dansk Tagbyg ApS

Vi er specialister i løsninger med tegltag og tilbyder markedets bedste undertag. Dette kombineret med vores mange års erfaring inden for taglægning, kan give dig et tegltag der kan holde i mere end 50 år. Vores håndværkere er specialiserede i tag og energiløsninger, og har solid erfaring inden for tømrerfaget.

Det er vigtigt for os at levere et professionelt arbejde i kvalitetsprodukter, til tiden og til en fornuftig pris.`,
    benefits: ["Høj kvalitet og lang levetid på 50-70+ år", "Dansk produceret højkvalitet", "Miljøbevidst valg uden kemiske bindemidler", "Storm- og brandsikkert", "Naturprodukt med minimal vedligeholdelse"]
  },
  {
    id: "betontag",
    slug: "betontag",
    title: "Betontag",
    category: "Nyt tag",
    description: "Hos Dansk Tagbyg er vi specialister i betontag. Det er en stærk og holdbar løsning. Kontakt os i dag for professionel rådgivning af betontag →",
    meta_title: "Betontag | Eksperter i betontag | Dansk Tagbyg - Dansk Tagbyg",
    meta_description: "Hos Dansk Tagbyg er vi specialister i betontag. Det er en stærk og holdbar løsning. Kontakt os i dag for professionel rådgivning af betontag →",
    image: "https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/scraped-1_5a1c0d38.webp",
    content: `Betontag kaldes også for betontagsten eller cementtagsten og er en populær form for tagbelægning, som du ser på mange danske huse. Betontagsten ser ud som på billedet herover og minder i udformning om de klassiske teglsten i lertegl. Forskellen er, at betontagsten er nemmere at fremstille og dermed også væsentlig billigere.

Betontegl består af en blanding af cement, vand og sand – samt eventuelt gennemfarvende farvestof – hvilket giver et materiale, som er utroligt slidstærkt. Betontag har også den fordel, at de har en lang levetid på mellem 50-70 år, forudsat at de er lagt helt korrekt fra starten af. Det gør vi naturligvis.

Betontegl er en meget tung tagsten. Det er derfor nødvendigt at få en fagpersons vurdering af, om din tagkonstruktion er solid nok til at bære betontagsten.

## Betontag - en stærk og holdbar løsning

Betontagsten er et af de mest populære valg af tag i Danmark, og som du ser på rigtig mange danske boliger. Betontag er også en type tag, der er produceret til det danske vejr med alle de udfordringer det giver i forhold til storm, regn, sne, sol mv. Med et nyt betontag på huset får du en af de mest holdbare løsninger på markedet.

Betontaget er et rigtig godt valg til et nyt tag.

### Stærkt, solidt og nemt at lægge

Betontagsten er målfast, holdbar og nemt at lægge. Betontag er en alsidig tagtype, som findes i mange forskellige farver, og med forskellige overflader – fx med og uden glans, hvilket gør det nemt for dig at finde den rette tagsten til dit hus. Er du i tvivl om, hvilken farve du skal vælge? Så kan det være en idé at køre rundt i dit villakvarter og finde lignende huse. Der kan du se, hvilken farve de har valgt, og om du synes, at det passer til husets udtryk og mursten.

Det skal nemlig være en betontagsten, som du først og fremmest kan lide, og så skal den naturligvis også passe til det resterende byggeri – altså selve dit hus og stilen på dit hus.

Med et betontag får du en stærk, solid og holdbar løsning. Deres tunge vægt gør, at betontagstenene kan modstå kraftig storm og blæst bedre end eksempelvis teglsten, som ikke er nær så tunge.

### Betontagsten er et billigt alternativ

I de fleste tilfælde vil et nyt betontag være en billigere løsning end et tegl- eller skifertag. Det er således samtidig med, at du også får et solidt og pænt tag, der kan holde dit hjem både tørt, sikkert og pænt i mange år fremover. Med et betontag får du et rigtig godt alternativ til et tegltag, stål eller skifertag.

Du sparer samtidig penge på materialer.

### Naturligt og holdbart

Betontag er en tung tagtype, og beslutter du dig for et betontag, så vil vi foretage en beregning for at sikre at den nuværende tagkonstruktion kan bære det nye og tungere tag. Er der allerede lagt et tungt tag skal der som regel ikke foretages yderligere forstærkninger. Betontagsten er lavet af en blanding af sand, cement, vand og farvestoffer, og er en af de mest holdbare tagløsninger på markedet. Som noget nyt kan du også få betontag, som er 40% lettere set i forhold til traditionelle betontagsten. Disse betontagsten har samme styrke, udseende og holdbarhed som de traditionelle og er et glimrende alternativ, hvis du ikke har en tagkonstruktion til tungt tag.

#### Fordele ved et betontagsten – som du bør kende:
- Betontagsten er produceret til at modstå det danske vejr
- De er meget holdbare og robuste
- Dit tag beholder sit nye, friske udseende i mange år
- Betontagsten er et rent naturligt, stærkt og let håndterbart materiale
- Det er et billigere alternativ til de dyrere tegltagsten

I betontaget får du altså et stærkt, solidt og naturligt tag, som stadig efter endda 10 år ser pænt ud. Derudover kan du mange gange spare 10-20 % i forhold til de klassiske røde teglsten.

#### Det skal du vide om betontag:
- Det kræver en professionel tagdækkers vurdering, om din tagkonstruktion er stærk nok og egnet til det tunge betontag.
- Det er teknisk krævende at lægge et betontag. Få derfor vores tagdækker til at lægge taget, så det kan holde længst tid muligt.
- Betontagsten kaldes også for cementtagsten, da de er lavet af en blanding af cement, sand og vand. I den blanding kan man tilsætte farvestof eller flyveaske for at opnå forskellige effekter og farver.
- Et betontag kræver et undertag, som støtter tagkonstruktionen, så den bliver tilstrækkeligt stærk til at bære tagstenene i beton.

## Hvornår man bør vælge betontag

Betontag er et oplagt valg for mange boligejere, især hvis man står og skal have nyt tag og gerne vil have en løsning, der både er robust og økonomisk fornuftig. Det er typisk et godt valg, hvis du ønsker et tag, der kan holde i mange år uden at kræve den store vedligeholdelse, og samtidig gerne vil have et klassisk udtryk på huset.

Mange vælger betontag, når det gamle tag er blevet slidt, eller hvis der er problemer som utætheder, begyndende fugt eller et tag der bare har set bedre dage. Det er også en løsning, der giver mening hvis man ønsker at forbedre boligens samlede værdi og samtidig få et mere moderne udtryk.

## Vedligeholdelse af betontag

Et betontag kræver generelt ikke meget vedligeholdelse, men lidt løbende opmærksomhed kan gøre en stor forskel for levetiden. De fleste oplever, at taget holder sig pænt i mange år, især hvis det bliver holdt fri for snavs, blade og begyndende belægninger.

Over tid kan der komme mos og alger på taget, afhængigt af omgivelserne og hvor meget skygge huset ligger i. Det er helt normalt og kan som regel fjernes med en nænsom rensning, så taget igen fremstår pænt og ensartet.

Det kan også være en god idé en gang imellem at få tjekket taget for løse eller beskadigede tagsten, især efter kraftigt vejr. Små reparationer i tide kan forhindre større skader senere og er naturligvis også noget, som vi er behjælpelige med her hos Dansk Tagbyg.

## Professionel rådgivning hos Dansk Tagbyg ApS

Vi er specialister i tagløsninger med betontag og tilbyder markedets bedste undertag. Dette kombineret med vores mange års erfaring inden for taglægning, kan give dig et betontag. der kan holde i mere end 50 år.

Vores håndværkere er specialiserede i tag- og energiløsninger. De har solid erfaring inden for tømrerfaget og speciale i tagdækning. Det er vigtigt for os at levere et professionelt arbejde i kvalitetsprodukter med et resultat, der bare er i orden. Vi lægger stor vægt på at levere til tiden og til den aftalte, fornuftige pris.`,
    benefits: ["Modstandsdygtigt over for det danske vejr", "Prisvenligt alternativ til tegl", "Lang levetid på 50-70 år", "Flere farver og overfladeglans", "Stor modstandsdygtighed mod storm og blæst"]
  },
  {
    id: "eternittag",
    slug: "eternittag",
    title: "Eternittag",
    category: "Nyt tag",
    description: "Få indsigt i eternittag, priser og udskiftning – inkl. asbest. Vi rådgiver om den rette løsning til din bolig. Kontakt Dansk Tagbyg i dag.",
    meta_title: "Eternittag – nyt tag, priser og udskiftning | Dansk Tagbyg ApS - Dansk Tagbyg",
    meta_description: "Få indsigt i eternittag, priser og udskiftning – inkl. asbest. Vi rådgiver om den rette løsning til din bolig. Kontakt Dansk Tagbyg i dag.",
    image: "https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/scraped-1_343ab3ba.webp",
    content: `Trænger dit hus til et nyt tag? Eternittag er en af de mest anvendte tagløsninger i Danmark – og det er ikke uden grund. Det er en let og robust tagtype, fremstillet af fibercement, som kombinerer holdbarhed, fleksibilitet og en fornuftig pris.

For mange boligejere er et nyt eternittag en oplagt løsning, når taget skal udskiftes. Det gælder især, hvis du ønsker et tag, der kræver minimal vedligeholdelse og samtidig kan modstå det danske klima med regn, blæst og skiftende temperaturer.

## Nyt eternittag – hvad skal du være opmærksom på?

Når du vælger et nyt eternittag, får du en løsning, der både er praktisk og alsidig. Eternitplader fås i flere udformninger – typisk som bølgeplader eller flade plader med et mere skiferlignende udtryk.

Eternit er et let materiale, hvilket betyder:
- Mindre belastning på tagkonstruktionen
- Mulighed for anvendelse på mange forskellige bygningstyper
- En hurtigere og mere enkel montering

Det gør eternit særligt velegnet til både helårshuse, sommerhuse, garager og tilbygninger, hvor der ønskes en solid løsning uden unødige omkostninger.

## Hvad koster et nyt eternittag?

Et centralt spørgsmål er naturligvis: “Hvad koster et nyt eternittag?”

Prisen på eternittag afhænger af flere faktorer:
- Tagets størrelse og hældning
- Valg af pladetype
- Kompleksitet (fx ovenlysvinduer og skorstene)
- Standen på eksisterende tag
- Om der er behov for udskiftning af eternittag med asbest

Generelt er eternit en af de mest økonomiske tagløsninger sammenlignet med tegl og skifer. Samtidig er det en løsning, der holder i mange år, hvilket giver en god balance mellem pris og levetid.

Ved hjælp af vores prisberegner for nyt tag kan du nemt finde frem til en estimeret pris på et nyt eternittag. Du er naturligvis også meget velkommen til at kontakte os og få et gratis og uforpligtende tilbud.

## Eternittag levetid og vedligeholdelse

Et korrekt monteret eternittag har typisk en levetid på 30–50 år. Materialet er modstandsdygtigt over for både fugt, svamp og råd, hvilket gør det særligt velegnet til det danske klima.

Samtidig kræver eternit kun begrænset vedligeholdelse. Det anbefales dog, at taget holdes rent for mos og alger, da ophobning af fugt kan påvirke levetiden over tid.

## Eternittag og asbest – vigtigt ved udskiftning

Hvis du har et ældre eternittag, er det vigtigt at være opmærksom på asbest. Mange tage fra før midten af 1980’erne indeholder asbest, og udskiftningen af disse skal udføres af autoriserede fagfolk såsom Dansk Tagbyg.

## Fordele ved eternittag

Eternit er et populært valg, fordi det kombinerer flere fordele:
- Lav pris sammenlignet med mange andre tagtyper
- Lang levetid
- Minimal vedligeholdelse
- Let materiale, der ikke kræver tung konstruktion
- Modstandsdygtigt over for vejr, fugt og svamp
- Brandhæmmende egenskaber
- Bidrager til sundt indeklima
- Fås i flere farver og udtryk

Det gør eternittag til en fleksibel løsning, der passer til mange typer boliger.

## Andre tagtyper – hvad er alternativerne?

Selvom eternittag er en god løsning, findes der også andre muligheder:
- **Tegltag** – klassisk og meget lang levetid
- **Betontag** – robust og prisvenligt alternativ
- **Skifertag** – eksklusiv løsning med minimal vedligeholdelse
- **Ståltag** – let og hurtigt at montere
- **Tagpap** – ideelt til flade tage

Valget afhænger af både budget, æstetik og konstruktion. Derfor rådgiver vi altid ud fra din konkrete bolig, og sammen med dig finder vi frem til den helt rigtige løsning til dig.

## Derfor vælger mange Dansk Tagbyg

Når du vælger Dansk Tagbyg til dit nye eternittag, får du en samarbejdspartner med fokus på kvalitet og overblik:
- Erfaring med tagprojekter siden 2016
- 4,8/5 stjerner fra +150 anmeldelser
- Fast kontaktperson gennem hele forløbet
- Arbejde udført efter gældende standarder
- Løsninger tilpasset din bolig og dit behov
- Kvalitets- og garantiordninger

Vi har solid erfaring med både eternittag udskiftning og nye tagløsninger – og vi rådgiver dig ærligt hele vejen.`,
    benefits: ["Lav pris sammenlignet med tegl/skifer", "Lang levetid på 30-50 år", "Minimal vedligeholdelse", "Let materiale (kræver ikke tung spærkonstruktion)", "Brandhæmmende fibercement"]
  },
  {
    id: "skifertag",
    slug: "skifertag",
    title: "Nyt skifertag",
    category: "Nyt tag",
    description: "Overvejer du et nyt skifertag? Få overblik over pris, skifertyper og dine muligheder. Kontakt Dansk Tagbyg for rådgivning og tilbud i dag.",
    meta_title: "Nyt skifertag – Pris, typer og montering | Dansk Tagbyg ApS - Dansk Tagbyg",
    meta_description: "Overvejer du et nyt skifertag? Få overblik over pris, skifertyper og dine muligheder. Kontakt Dansk Tagbyg for rådgivning og tilbud i dag.",
    image: "https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/scraped-1_bdb5c08e.webp",
    content: `Overvejer du et nyt tag, og ønsker du en løsning, der kombinerer æstetik, holdbarhed og minimal vedligeholdelse? Så er et skifertag et oplagt valg. Det er en tagtype, der skiller sig ud – både visuelt og teknisk – og som i mange tilfælde holder i generationer.

Et skifertag er ikke den billigste løsning her og nu, men til gengæld får du et tag, der kræver meget lidt vedligeholdelse og har en levetid, som langt overgår de fleste andre tagtyper. Derfor vælger mange boligejere skifertag, når de tænker langsigtet og ønsker en løsning, der både beskytter og løfter boligens udtryk.

## Nyt skifertag – hvad skal du vælge?

Der findes grundlæggende to typer skifertag:

### Naturskifertag
En eksklusiv løsning, ofte med en levetid på over 100 år. Naturskifer har et naturligt farvespil, der ikke falmer over tid, og giver et klassisk og roligt udtryk. Det er et 100 % naturmateriale og et oplagt valg, hvis du ønsker den mest holdbare og æstetiske løsning.

### Fibercementskifertag (kunstskifertag)
Et mere prisvenligt alternativ, der ligner naturskifer i udtryk. Det er lettere at arbejde med og stadig modstandsdygtigt over for det danske vejr. Levetiden er kortere end naturskifer, men stadig lang sammenlignet med mange andre tagtyper.

Fælles for begge løsninger er det elegante udtryk og den høje modstandsdygtighed. Et nyt skifertag er særligt velegnet til det danske klima og står stærkt mod både vind og nedbør.

## Hvad koster et skifertag?

Prisen på et nyt skifertag afhænger af flere faktorer, herunder:
- Valg af skifertype (natur eller fibercement)
- Tagets størrelse og hældning
- Kompleksitet (kviste, skorstene, ovenlysvinduer og lign.)
- Om undertaget skal udskiftes
- Eventuelle tilvalg og detaljer

Naturskifer er den dyreste løsning, men også den med længst levetid. Ser man på levetiden alene, er det ofte en af de mest rentable investeringer på sigt.

Vil du have en idé om prisen på et nyt skifertag til din bolig, kan du med fordel bruge vores prisberegner for nyt tag og få et hurtigt estimat.

## Fordele ved skifertag

Et skifertag er populært af en grund. Du får blandt andet:
- Meget lang levetid
- Minimal vedligeholdelse
- Et eksklusivt og tidløst udtryk
- Høj modstandsdygtighed over for vind og vejr
- Materialer, der ikke falmer i solen
- Lav vandoptagelse
- Mulighed for flotte og unikke detaljeløsninger

Kort sagt: Et skifertag er ikke bare en udgift – det er en investering i din bolig.

## Andre tagtyper – hvad er alternativet til skifer?

Selvom skifertag er en holdbar og eksklusiv løsning, findes der flere andre tagtyper, som kan være relevante afhængigt af din bolig og dit budget.

Hos Dansk Tagbyg arbejder vi blandt andet med:
- **Tegltag** – en klassisk og meget holdbar løsning med en levetid på op til 100 år
- **Betontag** – et solidt og mere prisvenligt alternativ til tegl
- **Eternittag** – let og fleksibelt materiale, ofte valgt til både renovering og nybyg
- **Tagpap** – oplagt til flade tage og tilbygninger
- **Ståltag** – en let løsning, som i nogle tilfælde kan monteres ovenpå eksisterende tag

Valget af tagtype har stor betydning for både husets udtryk, holdbarhed og vedligeholdelse. Derfor er det vigtigt at vælge en løsning, der passer til både konstruktion og behov.

Vi rådgiver altid ud fra din konkrete bolig – ikke ud fra standardløsninger.

## Hvorfor skal du vælge Dansk Tagbyg?

Når du investerer i et nyt skifertag, er det afgørende, at det bliver udført korrekt. Monteringen har stor betydning for både holdbarhed og udseende.

Hos Dansk Tagbyg får du:
- Erfaring med tagprojekter siden 2016
- 4,8/5 stjerner fra +150 anmeldelser
- Fast kontaktperson gennem hele forløbet
- Arbejde udført efter gældende standarder
- Garantiordninger, der sikrer dig efterfølgende

Vi rådgiver dig ærligt om, hvilken løsning der passer bedst til din bolig – også hvis skifer ikke er det rigtige valg.`,
    benefits: ["Eksklusivt, arkitektonisk og tidløst udtryk", "Naturskifer holder i over 100 år", "Ekstremt modstandsdygtigt over for storm og vejr", "Materialet falmer ikke i solen", "Meget lav vandoptagelse"]
  },
  {
    id: "staaltag",
    slug: "staaltag",
    title: "Ståltag",
    category: "Nyt tag",
    description: "Dansk Tagbyg leverer de bedste tagløsninger. Vi er specialister i tagdækning, nyt tag, ståltag og isolering.",
    meta_title: "Dansk Tagbyg – Eksperter i ståltag – din tagdækker i hele Danmark - Dansk Tagbyg",
    meta_description: "Dansk Tagbyg leverer de bedste tagløsninger. Vi er specialister i tagdækning, nyt tag, ståltag og isolering.",
    image: "https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/scraped-1_6abd2954.webp",
    content: `Ståltag er for dig, der vil have den gode kvalitet uden at skulle betale en bondegård. Ståltag er kendt som modstandsdygtige, solide og pæne med en levetid på mellem 50-80 år. Derudover er ståltag meget alsidigt og egner sig både til privat, erhverv, parcelhus og redskabsskur.

## Ståltag er populært, og det er med god grund

I de seneste år er ståltaget blevet et populært valg, og det skyldes formentligt, at et ståltag er særdeles alsidigt. Om der er tale om en renoveringsopgave eller et udskift af hele taget, er der mange fordele ved at vælge et ståltag.

Et ståltag er det oplagte valg for dig, som ønsker en nem og billig løsning, men ikke vil ofre kvaliteten. Med et ståltag får du nemlig et solidt og modstandstandsdygtigt tag, som også er pænt at kigge på. Om du er privat- eller erhvervskunde, eller om taget skal benyttes til parcelhus eller redskabsskur, er ligegyldigt. Der findes helt sikkert et ståltag, som opfylder dine behov og ønsker.

## Store besparelser på tid og penge med et nyt ståltag

At lægge et nyt ståltag er både nemt og overskueligt. Herudover er processen betydeligt hurtigere, da ståltagspladerne har en større overflade, hvilket betyder, at der skal lægges færre tagplader. Den effektive taglægning betyder, at der vil være færre omkostninger i forbindelse med montering. I mange tilfælde kan et ståltag endda lægges ovenpå et gammelt tag af eksempelvis bølgeplader eller tagpap, som i så fald vil fungere som et undertag. Ståltaget vejer ikke særlig meget, og det påvirker derfor ikke kvaliteten eller holdbarheden af taget at lægge det direkte ovenpå det nuværende tag. På denne måde undgår man også yderligere omkostninger til at fjerne og bortskaffe det gamle tag.

Når du vælger et ståltag fra Dansk Tagbyg, kan du selv vælge den variant af ståltag og den tagfarve, du ønsker. Herudover fås ståltag både som standardplader og som fixmålplader. Standardplader købes i faste mål, og de er dermed allerede udskåret forud for bestilling. Fixmålplader bestilles derimod med specifikke mål, som passer til netop dit tagprojekt. Det optimale valg af ståltag heraf vil variere alt efter arealet, som skal dækkes med tag. Dog vil standardplader som regel være det billigste valg, da de, i modsætning til fixmålplader, bliver masseproduceret. Er der tale om et større projekt, kan fixmålplader dog være fordelagtige, da det i nogle tilfælde kan lade sig gøre at få et godt tilbud på plader med selvbestemte mål.

## Værd at overveje om ståltage

Der findes et ståltag til dig, hvad end formålet er. Formålet er dog langt fra ligegyldigt, når der skal tages stilling til hvilken form for ståltag, der skal benyttes.

Du kan blandt andet overveje følgende spørgsmål:
- Er der tale om vedligeholdelse og renovering af dit tag, eller skal der monteres et helt nyt ståltag?
- Ønsker du et tag, som er modstandsdygtigt i forhold til alger og mos?
- Hvor lang garanti har du behov for på dit tag?
- Hvor stort et areal skal dit tag dække? Kunne det eventuelt være fordelagtigt for dig og dit tagprojekt, at få et tilbud på fixmålplader?
- Hvordan skal dit tag se ud? Skal det fremstå som klassiske teglsten? Skal det være mat eller blankt?

Hos Dansk Tagbyg benyttes der primært tag fra de to producenter Decra og Lindab, som hver især har sine fordele. Begge producenter laver tag i høj kvalitet, og priserne er næsten ens, men Lindab kan i nogle tilfælde være en smule billigere end Decra.

Med et Decra ståltag får du et tag, hvor kvaliteten er i top. Et Decra ståltag er produceret i Danmark, og pladerne er bygget op omkring en kerne af stål, som sikrer, at hver enkel tagplade er robust og holdbar. Pladerne er galvaniseret med aluzink og belagt med enten keramisk farvet stengranulat eller slagfast pulverlak. Med et Decra ståltag får du 30 års garanti.

Lindab Topline er produceret i Skandinavien. Med dette valg får du en klassisk tagstensprofil og en smuk, glat overflade på det færdige tag. Dette kan lade sig gøre, da Lindab Toplines patenterede faconklippede forkant og hjørneklip sikrer, at de individuelle pladeoverlæg fremstår usynlige. Den glatte overflade betyder også, at mos og alger ikke gror fast på taget, da der ikke er nok tekstur at tage fat i. Valget af Lindab Topline giver en lettere montering, og der ydes 40 års garanti på disse ståltage.

## Virker ståltag for godt til at være sandt?

Når prisen for et tag er lavere end normalt, er det naturligt at bekymre sig om, hvorvidt kvaliteten er i orden. Der er dog ingen grund til bekymring, da besparelserne ved valg af et ståltag udelukkende skyldes den hurtige monteringsproces, og kvaliteten af taget komprimeres derfor ikke. Faktisk er materialeprisen for et ståltag omtrent den samme, som for andre tagtyper. Ståltaget er holdbart og modstandsdygtigt, og der er lang garanti på tagene.

For mange virker et ståltag også som et valg, der må føre til uønsket støj ved nedbør. Så længe ståltaget ligger på et hus med normal isolering, er der dog ikke problemer med larm fra regnbyger. Er ståltaget placeret ovenpå et gammelt tag, fungerer dette endda som ekstra lydisolering.

Har du tagvinduer eller en skorsten, er dette heller ikke et problem, der skal stoppe dig fra at vælge et ståltag. Tagpladerne kan udskæres yderligere efter levering, og de kan derfor placeres rundt om udstående objekter på taget.

## Dansk Tagbyg sikrer dit ståltag langt ud i fremtiden

Dit tag skal ligge i mange år, og det skal holde til vind og vejr. Det er derfor vigtigt at sikre kvalitet og holdbarhed. Hos Dansk Tagbyg er vi specialister med mange års erfaring indenfor tagdækning med stålplader. Du kan derfor stole på at få kompetent rådgivning, hvor vi i fællesskab kan finde frem til den absolut bedste ståltagsløsning til din ejendom. Vi benytter kun kvalitetsprodukter, som alle er dækket af en lang garanti, og vi monterer dit tag med et holdbart resultat, som forbliver smukt mange år ud i fremtiden.`,
    benefits: ["Hurtig og tidsbesparende montering", "Særdeles god økonomi", "Kan ofte monteres ovenpå eksisterende tag", "Holdbarhed på 50-80 år", "Mange farver og profiler"]
  },
  {
    id: "decra-staaltag",
    slug: "decra-staaltag",
    title: "Decra ståltag",
    category: "Nyt tag",
    description: "Decra ståltag er en let og holdbar tagløsning med lang levetid og lav vedligeholdelse. Vi hjælper med rådgivning og montering. Kontakt os →",
    meta_title: "Decra ståltag | Holdbare og lette ståltage fra Dansk Tagbyg - Dansk Tagbyg",
    meta_description: "Decra ståltag er en let og holdbar tagløsning med lang levetid og lav vedligeholdelse. Vi hjælper med rådgivning og montering. Kontakt os →",
    image: "https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/scraped-1_fa4df807.webp",
    content: `Trænger dit tag til en renovering, eller har du brug for et helt nyt tag? Så er et ståltag en grundig overvejelse værdig. Et Decra ståltag er en billig kvalitetsløsning, som sikrer lang holdbarhed. Taget udstråler kvalitet, og det er et fornuftigt valg til renoveringsopgaven, til sommerhuset eller til nybyg. Decra egner sig ikke alene til nye bygninger, men ligeledes til renovering af gamle, da taget kan lægges ovenpå den slidte skifer eller på eternittage.

Et nyt Decra ståltag er for dig, som er prisbevidst og foretrækker at bruge dine penge fornuftigt. Monteringen af ståltaget er nem og effektiv, og der er derfor besparelser at hente på både tid og penge, i modsætning til andre populære løsninger som tegl eller tagpap. Materialeprisen er dog omtrent den samme som for andre typer af tag, og den lave pris skyldes dermed kun den betydeligt kortere monteringstid, som også sparer dig for uønsket byggerod i en længere periode.

## Det prisbevidste valg

Ståltaget vejer ikke særlig meget, og det kan derfor lægges ovenpå dit gamle tag, som så vil fungere som underlag til Decra-taget. Hermed skal der ikke tages højde for ekstra udgifter til eksempelvis nye spær eller bortskaffelse af dit gamle tag.

Ud over at være et økonomisk godt valg, er kvaliteten af et Decra ståltag også i top. Decras tagplader er bygget op omkring en stærk kerne af stål, som er galvaniseret med aluzink, og der sikres dermed høj kvalitet og lang levetid, da pladerne er robuste. De anvendte kraftige materialer forlænger ståltagets holdbarhed markant, og der ydes tilmed en gavmild garanti på 30 år, så din ejendom er sikret et tag af høj kvalitet langt ud i fremtiden.

Den stærke stålkerne giver tagpladerne en farveægthed, som ikke kendes fra andre tagmaterialer. Tagpladernes flotte ydre består af en keramisk indfarvet stenbeklædning, og den kan vælges i den farve, du ønsker. Tagpladernes udseende er også holdbart i alle vejrforhold, og regn vil som regel holde taget rent og pænt. Taget er tilmed let at vedligeholde, da det blot kan spules med vandslangen, hvis det skulle blive nødvendigt.

## Fordele ved et Decra ståltag

Hvis det kan være svært at overskue, præcis hvad Decras løsninger kan gøre for dig, er der herunder samlet en liste af fordele ved at vælge Decra til dit tagprojekt.
- Et Decra ståltag har 30 års produktgaranti, som også sikrer, at taget vil modstå vind og vejr i hele garantiperioden.
- Med et Decra ståltag er monteringen af taget nem og hurtig, hvilket gør valget billigere end mange andre tagløsninger.
- Den korte monteringstid betyder, at du slipper for byggerod og eventuel larm over længere tid.
- Decra har et varieret udvalg af farver, så du kan få det mest æstetiske resultat til din ejendom. Derudover får du valgmuligheden mellem en mat eller blank overflade alt afhængigt af, hvilket tag indenfor Decra produktsortiment du vælger.
- Taget kan ofte anvendes ved lav taghældning.
- Ståltagpladerne fra Decra har en kort lægteafstand, hvilket betyder, at taget ikke larmer mere end andre tage. Ønsker du ekstra sikring mod trommeregn, tilbyder Decras sortiment lyddæmpende plader til glæde for både husejer og naboer.
- Ståltaget har en lang holdbarhed og garanti, og det er samtidig økonomisk og smukt.

## Hvilket Decra-tag skal du vælge?

Decra har over 25 års erfaring med produktion af ståltag i Danmark, hvilket har ført til et imponerende produktsortiment af høj kvalitet og stor variation. Med udvalget af forskellige typer af ståltag, findes der helt sikkert en løsning, som passer til dit renoverings- eller byggeprojekt samt til din boligs arkitektur og visuelle udtryk. Fælles for alle typer Decra-tag er, at de er yderst modstandsdygtige i forhold til alle vejrforhold, og hverken regn, hagl, sne eller sol vil derfor forringe tagets holdbarhed eller flotte ydre.

Decras produktsortiment består blandt andet af Decra Classic, som er Decras oprindelige produkt, og det er et særdeles sikkert og populært valg. Classic har en bestrøning med stengranulat i to størrelser på overfladen, som giver taget en flot, mat overflade. Derudover fungerer stengranulatet som et lyddæmpende element, da regndråber vil splitte, når de rammer taget og derved formindske lyden af regnen både inde i huset og udenfor. Tagpladens udseende er klassisk og mat, og det minder derfor om traditionelle teglsten.

Er du mere til en glat tagoverflade, har Decra Elegances ståltag en slagfast lakering, hvilket giver taget et moderne og stilrent udseende, som holder sig smukt mange år. Decra Elegance har, i modsætning til Classic-taget, ikke lyddæmpende elementer, hvilket gør prisen fordelagtig. Denne tagplade egner sig derfor til store projekter med efterisolering, hvorved lyden vil dæmpes automatisk. Den er også et optimalt valg til projekter, hvor ståltaget lægges ovenpå det gamle tag, som derved vil fungere som ekstra lydisolering.

Ønsker du Decra Elegances æstetiske ydre, men med Decra Classics minimale lydniveau? Så er taget Decra Elegance Acoustic det oplagte valg. Dette tag har et lyddæmpningssystem monteret på bagsiden af pladen, som sikrer både dig og dine naboer for uønsket støj fra ståltaget, da pladens opbygning ændrer lydens resonans. Denne pladeopbygning er patenteret af Decra, og løsningen findes derfor ikke ved andre tagmaterialer.

## Decra ståltag vs andre tagtyper

Når du sammenligner Decra ståltag med andre tagtyper, er der flere ting, der typisk gør forskellen. I forhold til tegl og beton er Decra ofte en hurtigere og mere økonomisk løsning at montere, fordi vægten er lavere og arbejdet derfor går lettere. Det kan især mærkes på renoveringsopgaver, hvor det gamle tag nogle gange kan bruges som underlag.

I forhold til tagpap og andre bløde tagløsninger fremstår Decra mere robust, samtidig med at det kræver mindre vedligeholdelse. Det gør det til et godt valg for mange af vores kunder, der ønsker en holdbar løsning af nyt tag uden at gå på kompromis med udseendet.

## Er Decra egnet til dit hus?

Decra ståltag er en fleksibel løsning, som passer til mange forskellige typer boliger, men det er stadig vigtigt at vurdere, om det er det rette valg til netop din ejendom. Tagets hældning spiller en central rolle, da Decra typisk egner sig bedst til tage med en vis hældning, så vand og sne kan ledes korrekt væk. Her hos Dansk Tagbyg rådgiver vi naturligvis altid med afsæt i din konkrete situation, så du får den løsning, der passer bedst til både husets konstruktion og dine ønsker til udseende og levetid.

Det er også vigtigt at se på den eksisterende tagkonstruktion. På mange huse kan Decra lægges direkte ovenpå det gamle tag, hvilket gør løsningen både hurtigere og mere økonomisk. I andre tilfælde kræver det en vurdering af spær og bæreevne, så man sikrer, at konstruktionen er korrekt dimensioneret.

## Dansk Tagbyg ApS har stor erfaring

Hos Dansk Tagbyg er vi specialister i tagløsninger og kan hjælpe dig med at finde den bedste løsning til netop din ejendom. Vores håndværkere har solid erfaring inden for tag- og tømrerfaget og vi sætter en ære i at levere et professionelt arbejde. Derfor benytter vi kun kvalitetsprodukter, og vi leverer altid til tiden og til en fornuftig pris.

Dansk Tagbyg sikrer dig et tag, som ikke kan slides op. Vi giver 30 års produktgaranti på Decra ståltage og derudover også 15 års udførelsesgaranti, hvilket sikrer dit tag lang holdbarhed. Ud over garantien, sikres dit tag af Decras høje kvalitet og solide materialer. Tilmed monteres taget af kompetente tømrere, som har stor erfaring med montering af Decra ståltag.`,
    benefits: ["30 års produktgaranti + 15 års udførelsesgaranti", "Galvaniseret stålkerne med aluzink", "Lægges nemt ovenpå eksisterende tag", "Effektiv lyddæmpning med stengranulat", "Minimalt vedligehold"]
  },
  {
    id: "tagpap",
    slug: "tagpap",
    title: "Tagpap",
    category: "Nyt tag",
    description: "Få professionelt tagpap til dit tag. Holdbare og tætte tagpap-løsninger til både flade og skrå tage i hele Danmark. Indhent et uforpligtende tilbud →",
    meta_title: "Tagpap | Professionel lægning af tagpap| Dansk Tagbyg - Dansk Tagbyg",
    meta_description: "Få professionelt tagpap til dit tag. Holdbare og tætte tagpap-løsninger til både flade og skrå tage i hele Danmark. Indhent et uforpligtende tilbud →",
    image: "https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/scraped-1_5dda311d.webp",
    content: `Tagpap er et meget fleksibelt og stærkt tag, som egner sig til de fleste konstruktioner. Derudover er tagpap en billigere løsning end de fleste andre tagtyper, men har stadig en utroligt lang levetid på helt op til 50 år.

Tagpap giver huset karakter. Du kan vælge mellem listedækning eller helt fladt. Derudover er tagpap en billigere løsning end de fleste andre tagtyper, men har samtidig stadig en utroligt lang levetid på helt op til 50 år, når det er monteret korrekt af en kompetent fagmand. Skal vi lægge tagpap for dig? Så tag fat i os med det samme.

## Hvorfor skal du vælge tagpap til nyt tag?

Tagpap er et anerkendt produkt og en af de bedste og tætteste tagløsninger, som er flot, rent og arkitektonisk at se på. Derudover er tagpap mildere for din pengepung, det har en lang levetid, og du kan få matchende tag på dit hus og din garage.

Prisen på et nyt tag i tagpap afhænger af mange forskellige faktorer, navnlig: arealet af taget, antal lag af tagpap, om man bruger tagbrædder eller vandfast krydsfinér som underlag, hvorvidt der også skal laves lister omkring taget, og behovet for inddækning af rør og vinduer.

## Tagpap - et populært valg

Tagpap er en fleksibel og stærk tagløsning, som kan bruges til langt de fleste typer bygninger. Hos Dansk Tagbyg oplever vi, at det især bliver valgt til både nybyggeri og renovering, fordi det kan tilpasses mange forskellige tagformer og konstruktioner.

Det er især kendt for sin høje tæthed og lange levetid, som samtidig kræver minimal vedligeholdelse, hvilket gør det til en praktisk løsning, når der skal vælges nyt tag.

## Tagpap med listedækning?

Overvejer du denne løsning? Tagpaptag med listedækning giver taget et superflot arkitektonisk udtryk og bryder den glatte flade. Du får derfor et mere stilfuldt tag og en arkitektonisk bolig.

Når listedækning af tagpap er så populært, skyldes det blandt andet, at det giver arkitekten eller tagdækkeren flere kreative muligheder for at skabe et unikt, arkitektonisk udtryk på dit tag.

De lodrette påmonteringer, der udgør listedækningen, gør taget endnu mere tæt, men det har også den fordel, at de bryder de ellers monotone overflader og giver dem struktur, rytme og et mere eksklusivt udseende.

## Vedligeholdelse af tagpap

Et tag med tagpap kræver generelt meget lidt vedligeholdelse sammenlignet med mange andre tagtyper. Hos Dansk Tagbyg anbefaler vi dog stadig, at taget bliver gennemgået med jævne mellemrum, så eventuelle små skader eller tegn på slid bliver opdaget i god tid.

Særligt omkring samlinger, kanter og inddækninger kan det være en fordel med et eftersyn. Ved at holde øje med de områder kan man forlænge tagets levetid betydeligt og sikre, at det forbliver tæt i mange år.

### Tagpap fordele:

- Giver huset et flot udtryk
- Fleksibel tagløsning
- Et stærkt tag med lang levetid
- Tagpap er 100 % tæt
- Kan bruges på alle taghældninger og er særligt velegnet til brug som fladt tag
- Tagpap kræver minimal vedligeholdelse
- Konkurrencedygtig og unikt udtryk

Kontakt os for at høre mere. Ønsker du rådgivning fra vores faglærte tagdækkere eller et tilbud, er du altid velkommen til at kontakte os. Vi står klar til at rådgive og vejlede dig i forhold til valg af tag med tagpap – og andre typer nyt tag – og hvorvidt de er den rette løsning for dig.`,
    benefits: ["100 % tæt og ideelt til flade og skrå tage", "Arkitektonisk flot med listedækning", "Op til 50 års levetid", "Fleksibelt og stærkt materiale", "Konkurrencedygtig pris"]
  },
  {
    id: "tagrender",
    slug: "tagrender",
    title: "Tagrender",
    category: "Nyt tag",
    description: "Dansk Tagbyg leverer de bedste tagløsninger. Vi er specialister i tagdækning, nyt tag og isolering.",
    meta_title: "⇒ Tagdækker i Aarhus og omegn | Tagrender | Dansk Tagbyg ApS - Dansk Tagbyg",
    meta_description: "Dansk Tagbyg leverer de bedste tagløsninger. Vi er specialister i tagdækning, nyt tag og isolering.",
    image: "https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/scraped-1_f03d5c06.webp",
    content: `Når du skal vælge tagrender til dit hus, er der et hav af valgmuligheder. Tagrender fås i alle former, udstøbninger og farver, og valget er dit.

Med en tagløsning fra Dansk Tagbyg ApS er tagrender altid inkluderet i prisen. Dette kan dog fravælges, hvis I ikke ønsker at få nye tagrender. Vi tager naturligvis en snak med jer om, hvilken type tagrender I ønsker. Derpå stykker vi en skræddersyet løsning sammen til jer. Vi sørger for et komplet tagrendesystem til dit hus.

## Forskellige typer nye tagrender

Hos Dansk Tagbyg kan vi tilbyde at montere tagrender i både:
- Aluzink
- Kobber
- Zink

Alle tre ovenstående typer tagrender er kendt som værende meget stærke og udført i et materiale, der kan holde til og modstå det danske vejr. De holder sig intakte og pæne selv efter mange år med regn, blæst, slud og stærk sol. De forskellige tagrender passer hver især til de forskellige tagtyper og giver et smukt udseende på huset.

Med de rette tagrender har du styr på, hvor regnvandet ledes hen, så du mindsker risikoen for oversvømmelse og vandskader i dit hus. Vælger du en af de typer, der holder op til 25 år, så foretager du også et bæredygtigt valg – både for miljøet og din pengepung.

Når du får Dansk Tagbyg til at monteres tagrenderne for dig, behøver du ikke bekymre dig om at få alt det rette tilbehør med. Det sørger vi for!

### Aluzink-tagrende
**Det stærke og solide valg af tagrender.**
Aluzink-tagrender har en levetid på op til 15 år. De er lavet i kvalitetsstål med en belægning af aluminium og zink. Kan monteres med lim eller med gummisamling. Aluzink-tagrender tåler de største udfordringer, som det danske vejr kan byde på. Bør ikke anvendes sammen med tagpap uden UV-beskyttende overpap. Fås i forskellige rundinger. Kontakt os for at høre nærmere om, hvad der passer bedst til din bolig.

### Zink-tagrender
**Det eksklusive og originale valg inden for tagrender.**
De originale og populære zink tagrender er et holdbart valg, der giver dig tagrender i op til 25 år, inden du får brug for at skifte dem ud igen. Tagrender i zink får med tiden en flot mørk patina. De er meget robuste og tåler det voldsomste vejr. Nye tagrender i zink monteres med lim eller loddes. Anvendes ikke sammen med tagpap, der ikke har en UV-beskyttende overpap. Zinktagrender fås i forskellige typer. Ring for faglig rådgivning og vejledning.

### Kobber-tagrender
**Det elegant og meget eksklusive valg af tagrender.**
De massive kobber tagrender har et eksklusivt look, som med tiden får den unikke, grønne og beskyttende patina, der kendes som ir – et grønt og dekorativt lag. Tagrender af kobber har en lang levetid på op til 25 år. Kobbertagrender tåler alt slags vejr – selv det værste vejr og saltholdigt luft er ingen udfordring for kobbertagrenderne. De kan loddes eller limes ved montering. En af de fede ting ved kobber er også, at tagrenderne kan monteres og anvendes sammen med alle tagtyper.

Ring til os og hør mere om dine muligheder.`,
    benefits: ["Aluzink, Zink og Kobber muligheder", "Standard inkluderet ved nyt tag", "Effektiv afledning af regnvand", "Sikrer boligen mod fugtskader", "Lang levetid op til 25+ år"]
  },
  {
    id: "isolering",
    slug: "isolering",
    title: "Isolering",
    category: "Energiløsninger",
    description: "Dansk Tagbyg leverer de bedste tag- og energiløsninger. Vi er specialister i tagdækning, nyt tag og isolering.",
    meta_title: "⇒ Tagdækker i Aarhus og omegn | Billig isolering | Dansk Tagbyg ApS - Dansk Tagbyg",
    meta_description: "Dansk Tagbyg leverer de bedste tag- og energiløsninger. Vi er specialister i tagdækning, nyt tag og isolering.",
    image: "https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/scraped-1_35c0ba3a.webp",
    content: `Er dit loftsrum og tag ikke tilstrækkeligt isoleret, vil din bolig have et højt varmetab, og det kan også skabe et usundt og ubehageligt indeklima. Med efterisolering af boligen kan du både spare penge på varmeregningen og få et bedre og mere stabilt indeklima.

Faktisk sker nemlig omtrent 25 % af varmetabet i en almindelig husstand gennem loftet og taget. Så efterisoleringsdelen kan blive det, der giver dig en af de største gevinster ved at skifte taget. I de fleste tilfælde vil det være relevant at overveje efterisolering, hvis du har planer om en større ombygning eller renovering af taget.

Udover den økonomiske gevinst ved at udskiftet taget vil det også gøre en stor forskel for indeklimaet. Så når du sætter dig i sofaen, bevæger dig rundt i huset året rundt og ligger i din seng, vil du bemærke, at temperaturen i dit hus er mere stabil, konstant og lettere at holde på et bestemt niveau, fordi der ikke går så stor en del af varmen tabt gennem loftrummet og taget. Det mindsker også træk og gør det langt mere behageligt at opholde sig i de forskellige rum.

## Lad Dansk Tagbyg stå for energioptimeringen af din bolig

Hos Dansk Tagbyg hjælper vi gerne med isolering af dit tag eller loft. Vi sørger for, at isoleringen lever op til alle krav og standarder, der er i dag, og vi står for alt det praktiske før, under og efter isoleringen.

Tag endelig fat i os, hvis du har brug for at høre mere eller prøv vores prisberegner, hvor du kan få et prisestimat på isolering af dit loft.

## Efterisolering af loft og tag er godt for pengepungen og for miljøet

Energiforbruget er unødvendigt højt i mange ældre huse, som er dårligt eller slet ikke isolerede. Er dit hus 8-10 år gammelt eller ældre kan du med meget stor sandsynlighed sænke dit energiforbrug betydeligt. Med en efterisolering kan dit hus blive langt mere energirigtigt. Det mindsker CO2-udledningen og – lækrest af alt – så sparer du også en masse penge på varmeregningen.

Loft og tag er det sted, hvor det bedst kan betale sig at efterisolere, da der kan ske meget store varmetab. Dit tag og loft udgør en af de største dele af klimaskærmen i dit hus. Varmetabet gennem taget er typisk 12 % højere end varmetabet gennem ydervæggen.

Det betyder, at toppen af dit hus står for omkring 25 % - og ofte endda mere afhængigt af den eksisterende isoleringsmængde – af al varmetab fra din bolig, da taget er så stor en flade, og varme søger opad.

At efterisolere dit loft og tag er et af de energitiltag, der kan spare dig allerflest penge. Det er dermed også den energiforbedring, der hurtigst tjener sig hjem. For loftisolering – det virker bare!

## Bedre indeklima og lavere varmeregning ved isolering

Isolering eller efterisolering af din bolig er ofte den nemmeste, hurtigste og billigste vej til at nedbringe varmeregningen. Når du får lagt ekstra isolering på loftet, får du virkelig smæk for skillingen. På bare tre til fire år vil omkostningerne ved efterisolering af dit loft være tjent hjem igen, så du får direkte gavn af besparelsen.

Efterisolering har dog ikke kun en gavnlig effekt på dit budget. Det kan også tydeligt mærkes på dit indeklima.

Opsummerende kan vi altså sige, at der er 3 fantastisk gode grunde til at få loftisolering:
- Du sparer penge på varmeregningen
- Din bolig stiger i værdi
- Du får et bedre indeklima

## Gør din bolig energirigtig – med efterisolering af dit loft

Som nævnt vil det i langt de fleste tilfælde kunne betale sig at efterisolere loftrummet eller taget på dit hus, hvis du har planer om en større ombygning eller renovering af taget. Faktisk har du ifølge Bygningsreglementet pligt til at efterisolere din bolig, når du er i gang med at renovere – såfremt det er rentabelt at isolere. Altså hvis pengene når at tjene sig hjem igen i løbet af isoleringens levetid.

Efterisolering af loftet er en enkel måde at gøre din bolig energirigtig. Det kan i mange tilfælde endda betyde, at dit hus kan få tildelt en bedre energimærkning. Dét er noget, der kan ses på salgsprisen.

### Fordele ved at isolere loft:
- Sænker varmeregningen markant og tjener sig hurtigt hjem
- Udleder mindre CO2 til gavn for miljøet
- Skaber et forbedret og mere stabilt indeklima
- Kuldebroer forhindres, da det er den bedste form for isolering
- Forhindrer skimmelsvamp og råd
- Giver en mere effektiv lydisolering
- Isoleringen kan lægges direkte på loftsgulvet
- Skaber en merværdi i boligen og øger salgsprisen

Den type isolering, som vi bruger, hedder Supafil Frame, som er en ubundet glasuldisolering med en eminent isoleringsevne:
- Euro-Class A1 og dermed ikke-brændbar
- Fremstillet af 80 % genbrugsmateriale
- Nem at håndtere og installere
- Reducerer energiforbruget og energiomkostninger
- Høj kvalitet og CE-mærket

## Hvor meget isolering skal der til?

Hvis du vil opnå lavenergi-status, skal du sørge for at få efterisoleret dit loft op til minimum 300 mm og meget gerne 400 mm og mere – for at opnå den maksimale varmebesparelse. Det giver den bedste økonomi i projektet på lang sigt.

Generelt anbefaler vi, at hvis du har mindre end 175 mm isolering liggende på loftet, så skal du efterisolere. Har du 250 mm loftisolering, kan det stadig oftest betale sig at isolere dit loft yderligere.

### Sådan måler du din eksisterende mængde/lag isolering
1. Tag tommestokken med på loftet.
2. Stik tommestokken ned i isoleringen. Gør det fortrinsvist langs kanten, så du ved, at du stikker den lige ned.
3. Aflæs på tommestokken, hvor mange millimeter isolering der ligger.
4. Mål gerne flere steder – for en sikkerheds skyld.

## Få råd til efterisolering af vores isoleringseksperter

I Dansk Tagbyg har vi stor erfaring med isolering og efterisolering, så din bolig kan blive energirigtig. Det betyder, at du kan ignorere alt det tekniske, krav til bygningsreglement og bestilling af materialer. Vi ordner det hele for dig og tager hånd om den samlede proces.

Kontakt os for et uforpligtende tilbud. Vi ser meget frem til at høre fra dig og sammen finde ud af, hvordan vi gør din villa endnu mere energivenlig og varmebesparende.`,
    benefits: ["Reducerer varmetab gennem taget med op til 25%", "Tjener sig hjem på blot 3-4 år", "Giver bedre og mere stabilt indeklima", "Euro-Class A1 ikke-brændbart glasuld", "Forbedrer boligens energimærke og salgsværdi"]
  },
  {
    id: "vinduer-og-doere",
    slug: "vinduer-og-doere",
    title: "Nye vinduer og døre",
    category: "Energiløsninger",
    description: "Dansk Tagbyg leverer de bedste tagløsninger. Vi er specialister i tagdækning, nyt tag, nye vinduer og døre og isolering.",
    meta_title: "⇒ Tagdækker i Aarhus og omegn | Nye vinduer og døre | Dansk Tagbyg ApS - Dansk Tagbyg",
    meta_description: "Dansk Tagbyg leverer de bedste tagløsninger. Vi er specialister i tagdækning, nyt tag, nye vinduer og døre og isolering.",
    image: "https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/bd5527e7e9ab5475005699d843fcbec00d331ef5.jpg",
    content: `Der stilles i dag højere krav til boligens vinduer og døre, og med nye energiforbedrede vinduer og døre kan du imødekomme disse krav samt spare penge, øge salgsværdien på huset, få forbedret indeklima og skabe en synlig visuel forbedring af facaden ude og inde.

Vi er specialister i energiløsninger til din ejendom, herunder også montering af vinduer og døre. Med mange års erfaring i montage af vinduer og døre kan vi hjælpe dig med at finde de bedste løsninger til din bolig, og vi sørger altid for, at alt spiller.

## Derfor kan det betale sig at investere i nye vinduer og døre

Med nye vinduer og døre sparer du på varmeforbruget, da en stor del af husets varmetab sker gennem vinduer og døre. Faktisk lever mange af de danske huse ikke op til de strenge krav, der i dag stilles til vinduernes og dørenes isoleringsevne.

Med energirigtige vinduer og døre får du bl.a.:
- **Udnytte solens stråler optimalt**: Energirigtige vinduer og døre er designet til at lukke gratis solvarme ind, samtidig med at varmen inde fra boligen reflekteres i glasset. Luftmellemrummet i glassene styrker isoleringseffekten og indeklimaet i huset optimeres.
- **Et bedre miljø inde og ude**: Husets indeklima og miljø, din komfort og din varmeregning afhænger alt sammen af kvaliteten af dine vinduer og døre. De fleste vinduer og døre er i dag lavet med friskluftsventilation, som betyder, at du kan lufte ud, uden at åbne vinduet. Daglig udluftning nedsætter forekomsten af husstøvmider, skimmelsvamp og kondens.
- **Giv huset ny karakter og facade**: Nye vinduer og døre kan være med til at give boligen et visuelt løft, hvilket både er dejligt for jeres øjne – men også en faktor, der kan være med til at øge boligens værdi, hvis huset en dag skal sælges.

## Hvornår bør vinduer og døre udskiftes?

Vinduer og døre holder ikke evigt, og med tiden kan både rammer, karme, tætningslister og ruder blive slidte. Det kan give dårligere isolering og gøre boligen mindre komfortabel.

Tegn på, at det kan være tid til nye vinduer eller døre, kan blandt andet være:
- Træk eller kulde omkring vinduerne
- Slidte eller utætte tætningslister
- Råd eller skader i rammer og karme
- Punkterede termoruder
- Vinduer og døre, der er svære at åbne eller lukke
- Højt varmetab gennem ældre vinduer
- Kondensproblemer, som bør undersøges nærmere

Det er ikke altid nødvendigt at udskifte alle vinduer og døre på én gang. Vi hjælper gerne med at vurdere den eksisterende løsning og finde ud af, hvor en udskiftning giver bedst mening.

## Kombinér nye vinduer med energirenovering af boligen

Hvis du allerede overvejer at energirenovere huset, kan det være relevant at se på vinduer og døre sammen med boligens øvrige klimaskærm.

Nye energivinduer kan eksempelvis kombineres med efterisolering, hvis boligen samtidig har utilstrækkelig isolering. Står dit hus foran en større renovering, kan det derfor være en fordel at få vurderet flere energiforbedringer samlet.

Hos Dansk Tagbyg arbejder vi med forskellige energiløsninger til boligen, herunder også solceller. Vi kan derfor hjælpe med at se på, hvilke forbedringer der giver mening for netop dit hus frem for udelukkende at fokusere på ét enkelt element.

Skal vi give dine vinduer og døre nyt liv? Kontakt os via formularen eller direkte på tlf. 28 68 74 50.`,
    benefits: ["Energirigtige 3-lags ruder", "Formindsker varmetabet markant", "Forbedrer indeklima og udluftning", "Styrker facadens udtryk", "Professionel tømrermontage med stillads og finish"]
  },
  {
    id: "solceller",
    slug: "solceller",
    title: "Solceller på tag",
    category: "Energiløsninger",
    description: "Overvejer du solceller på dit tag? Få overblik over pris, installation og muligheder. Vi rådgiver om solceller på tag og komplette løsninger.",
    meta_title: "Solceller på tag – pris, rådgivning og montering - Dansk Tagbyg",
    meta_description: "Overvejer du solceller på dit tag? Få overblik over pris, installation og muligheder. Vi rådgiver om solceller på tag og komplette løsninger.",
    image: "https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/scraped-1_5dd6e580.webp",
    content: `Overvejer du at få solceller på dit tag? Flere og flere boligejere vælger solceller for at producere deres egen strøm, reducere elregningen og gøre boligen mere energieffektiv.

Hos Dansk Tagbyg hjælper vi boligejere med rådgivning og løsninger inden for solceller og tag. Vi tager udgangspunkt i din bolig, dit elforbrug og dit eksisterende tag for at finde den løsning, der giver bedst mening – både teknisk og økonomisk.

Solceller er ikke bare en energiløsning. Det er en investering i din bolig og din fremtidige økonomi.

## Hvordan virker solceller?

Solceller omdanner solens energi til elektricitet, som du kan bruge direkte i din bolig. Panelerne monteres typisk på taget, hvor de opsamler sollys og producerer strøm i løbet af dagen.

Den strøm, du ikke selv bruger, kan enten:
- Sælges tilbage til elnettet
- Gemmes i et batteri til senere brug

Det betyder, at du kan reducere din afhængighed af elpriser og samtidig gøre din bolig mere selvforsynende.

## De mange fordele ved solceller på tag

At investere i solceller rummer en lang række fordele, som blandt andet omfatter:
- Mulighed for at reducere din elregning
- Du producerer vedvarende energi på din egen bolig
- Du kan sælge overskydende energi
- Solceller har en lang holdbarhed

Med solceller på taget af dit hus kan du spare både penge og mindske boligens klimaaftryk fra elforbruget. Solceller gør din bolig mere energirigtig og er samtidig en stort set vedligeholdelsesfri investering.

## Hvad koster solceller?

Et af de mest stillede spørgsmål er: “Hvad koster solceller?”

Prisen på et solcelleanlæg afhænger af flere faktorer:
- Tagets størrelse og hældning
- Antal paneler og anlæggets størrelse
- Valg af inverter og system
- Om du ønsker batteriløsning
- Kompleksiteten ved installationen

Vi har stor erfaring med rådgivning om og montering af solceller på tag og hjælper hellere end gerne, hvis du ønsker et gratis og uforpligtende tilbud eller har spørgsmål.

## Kan solceller betale sig?

For mange boligejere er svaret ja – det kan godt betale sig at investere i solceller på tag.

Hvor god økonomien i et solcelleanlæg bliver, afhænger dog blandt andet af anlæggets pris og størrelse, dit elforbrug, dit forbrugsmønster og hvor stor en del af strømmen du selv kan udnytte. Solceller kan:
- Reducere den strøm, du skal købe fra elnettet
- Give dig mulighed for selv at producere en del af boligens strøm
- Gøre boligen mere energieffektiv
- Gøre dig mindre afhængig af stigende elpriser

Jo mere af strømmen, du selv bruger, desto bedre kan økonomien i solceller blive.

## Solceller på tag – hvad skal du være opmærksom på?

Når du får monteret solceller på tag, er det vigtigt, at installationen udføres korrekt.

Vi vurderer altid:
- Tagets tilstand og bæreevne
- Tagets hældning og orientering
- Skyggeforhold fra omgivelser
- Integration med eksisterende tag

I nogle tilfælde giver det mening at kombinere med en tagudskiftning – især hvis taget alligevel nærmer sig slutningen af sin levetid. Vi rådgiver dig ærligt om, hvad det bedste valg for dig og din bolig er.

## Solceller på eternittag

Solceller kan monteres på forskellige tagtyper, men har du et ældre eternittag, er der nogle særlige forhold, du bør være opmærksom på.

Ældre eternitplader kan indeholde asbest. Derfor er det vigtigt at få afklaret tagets materiale og stand, inden der udføres arbejde på taget. Arbejde med asbestholdige materialer er underlagt særlige regler og må ikke behandles som almindeligt tagarbejde.

Hvis dit eternittag samtidig er slidt eller nærmer sig en udskiftning, kan det være mere hensigtsmæssigt at få etableret et nyt tag, før solcellerne monteres.

Hos Dansk Tagbyg er vi autoriseret til nedtagning af asbestholdige tage og kan derfor hjælpe med at se på den samlede løsning, hvis du både står med et ældre tag og ønsker solceller.

## Derfor skal du vælge Dansk Tagbyg

Når du vælger os til dit solcelleprojekt, får du en samarbejdspartner med fokus på helheden:
- Erfaring med både tag og energiløsninger
- 4,8/5 stjerner fra +150 anmeldelser
- Fast kontaktperson gennem hele forløbet
- Rådgivning om både tag og solceller i én løsning
- Fokus på kvalitet og realistiske løsninger
- Kvalitets- og garantiordninger

### FAQ: Ofte stillede spørgsmål om solceller:

- **Hvor mange solceller skal jeg bruge til mit hus?**: Antallet af solceller afhænger blandt andet af dit elforbrug, den tilgængelige tagflade og anlæggets forventede produktion. Anlægget bør dimensioneres med udgangspunkt i boligen og dit forventede strømforbrug.
- **Hvilken tagretning er bedst til solceller?**: Tagets orientering har betydning for produktionen, men solceller behøver ikke nødvendigvis at vende mod syd for at være relevante. Hældning, orientering og skyggeforhold vurderes altid individuelt.
- **Skal taget være nyt, før man monterer solceller?**: Nej, er taget i god stand og har passende restlevetid, kan solceller fint monteres på det eksisterende tag. Er det derimod slidt, bør tagudskiftning overvejes først.
- **Er et batteri nødvendigt til solceller?**: Nej, anlægget kan fint fungere uden. Batteriet giver mulighed for at gemme overskudsstrøm til aften- og nattetimer.`,
    benefits: ["Reducerer elregningen markant", "Producerer grøn og vedvarende energi", "Øger boligens markedsværdi", "Gør boligen mindre afhængig af elpriser", "Kan kombineres med nyt tag og garanti"]
  },
  {
    id: "algebehandling",
    slug: "algebehandling",
    title: "Algebehandling",
    category: "Vedligeholdelse",
    description: "Dansk Tagbyg – Eksperter i algebehandling og vedligeholdelse af alle tagtyper. Kontakt os i dag for at booke tid til algebehandling.",
    meta_title: "Dansk Tagbyg – Eksperter i algebehandling og vedligeholdelse af alle tagtyper - Dansk Tagbyg",
    meta_description: "Dansk Tagbyg – Eksperter i algebehandling og vedligeholdelse af alle tagtyper. Kontakt os i dag for at booke tid til algebehandling.",
    image: "https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/b02757f582f27eeda4044a240028e07448ea56ee.jpg",
    content: `En algebehandling giver dit tag den tiltrængte saltvandsindsprøjtning, som det hungrer efter. Med et speciallavet algemiddel giver vi dit tag den nødvendige behandling, der sikrer, at dit tag er mere modstandsdygtigt over for alger, der på sigt kan være skadende for dit tag.

En algebehandling er bygget op som følger:
Først og fremmest renser vi dit tag samt alle tagrender, så algemidlet kan virke på en ren overflade.
Dernæst påfører vi et speciallavet algemiddel på dit tag, der sikrer, at alle mikroorganismer langsomt nedbrydes og dit tag får de bedste forudsætninger for at kunne modstå alger i fremtiden. Det er vigtigt, at algebehandlingen foretages på en tør og frostfri dag, så midlet kan få lov at virke og trænge godt ind i overfladen.

Uanset hvilket tag du er indehaver af, kan det med sikkerhed tåle en algebehandling. Vores algebehandlinger er nemlig lavet til alle slags belægninger - alt lige fra tegltag til skifertag.

### 3 tydelige tegn på alger på taget:

- **Misfarvede pletter** – et sikkert tegn på algeforekomst er gule eller grønne misfarvede pletter, som er synlige selv på lang afstand.
- **Ophobning af mos** – algerne nedbryder overfladebehandlingen på dine tagsten og skaber dermed gunstige forhold for mos, der elsker fugtige miljøer.
- **Revnede eller forskubbede tagsten** – når alger æder overfladebehandlingen op, bliver tagstenene sårbare overfor frostsprængninger om vinteren.

## God vedligeholdelse er ofte den bedste investering

Du vil blive overrasket over, hvor mange fordele der er ved at sikre en jævnlig vedligeholdelse af dit tag:
- **Sundt og flot udseende** – alger danner grimme pletter. Med en algebehandling bevarer taget en flot og velplejet overflade.
- **Forebygger fremtidige skader** – alger slår rødder i tagsten og ødelægger overfladen, hvilket kan føre til fugt og skader på tagkonstruktionen.
- **Forlænger tagets levetid** – med den rette vedligeholdelse udskyder du en dyr tagudskiftning.
- **Undgå frostskader** – algebegroning opsuger vand, der om vinteren kan sprænge tagstenene itu.
- **Forøger ejendomsværdien** – et velplejet tag er et stærkt kort på hånden ved et fremtidigt boligsalg.

## Vores erfaring er din garanti for et godt resultat

Når det kommer til algebehandling, kan det være en god idé at få hjælp udefra:
- **Miljørestriktioner**: Der er strenge lovkrav til opsamling af spildevand efter algebehandling. Algemidlet må ikke løbe i grundvandet. Vi overholder alle miljøregler.
- **Effektive remedier**: Vi har professionelt udstyr, der renser hurtigt, skånsomt og effektivt.
- **Spar tid og energi**: Du kan læne dig tilbage og lade fagfolk klare arbejdet sikkert og ordentligt.`,
    benefits: ["Beskytter overfladebehandlingen mod nedbrydning", "Forebygger frostsprængninger og mosevækst", "Forlænger tagets levetid", "Overholder alle miljørestriktioner", "Skånsomt for alle tagtyper"]
  },
  {
    id: "fliserens",
    slug: "fliserens",
    title: "Fliserens",
    category: "Vedligeholdelse",
    description: "Er du ved at være godt træt af dine grimme, nedslidte fliser? Føler du, at det er ved at være tid til en god og grundig fliserens, der kan vække dine fliser tilbage til livet igen?",
    meta_title: "Fliserens - Dansk Tagbyg",
    meta_description: "Er du ved at være godt træt af dine grimme, nedslidte fliser? Føler du, at det er ved at være tid til en god og grundig fliserens, der kan vække dine fliser tilbage til livet igen?",
    image: "https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/0941b171d5cf754e2eeea82f67c4db1b5ab81e95.jpg",
    content: `Er du ved at være godt træt af dine grimme, nedslidte fliser? Føler du, at det er ved at være tid til en god og grundig fliserens, der kan vække dine fliser tilbage til livet igen? Med en professionel fliserens vil du på hurtig og effektiv vis få ordnet dine fliser, så de fremstår knivskarpe igen - ligesom da du købte dem.

Mange bliver overraskede over, hvor stor en forskel en fliserens kan gøre. I stedet for at investere i helt nye fliser, kan det faktisk betale sig at sikre en god vedligeholdelse af dine eksisterende fliser, så du kan få glæde af dem i mange år fremover.

Hos Dansk Tagbyg er vi eksperter i tagdækning, algebehandlinger samt fliserens, og vi udbyder vores service i store dele af Jylland - heriblandt både i Brande, Skanderborg, Silkeborg, Randers, Herning m.m.

## De hyppigste årsager til nedslidte fliser

Blandt de hyppigste årsager finder du:
- **Mos og ukrudt** – mos trives i skyggefulde og fugtige områder, og ukrudt titter hurtigt frem i fugerne.
- **Flisepest** – kaldes også for hvid lav og viser sig som genstridige hvidgrå pletter på fliserne.
- **Alger** – viser sig som mørkegrønne belægninger, der gør fliserne glatte og grimme.
- **Sort lav** – ligner små oliepletter og sætter sig dybt i flisens porer.

## Sådan foregår en fliserens i praksis

Når vi udfører en professionel fliserens, indebærer det:
1. **Fliserens**: Vi renser fliserne i bund med specialudstyr uden at beskadige overfladen.
2. **Algebehandling**: Efter rensningen påføres algebehandling for at dræbe eventuelle dybereliggende sporer.
3. **Imprægnering**: Forsegler overfladen, så fliserne holder sig pæne og modstandsdygtige i lang tid fremover.

## Professionel hjælp er den bedste investering
- **Effektive midler og udstyr**: Vi har maskinerne til at fjerne selv de sværeste belægninger.
- **Tidsbesparende**: Hurtigt og effektivt udført uden at du behøver at løfte en finger.
- **Ekspertise og erfaring**: Vi rådgiver dig om den rette efterbehandling og fugevedligeholdelse.`,
    benefits: ["Giver fliserne deres originale udseende tilbage", "Bekæmper flisepest, alger og mos effektivt", "Forlænger flisebelægningens levetid", "Skånsom professionel rensning og imprægnering", "Sparer udgifter til nye fliser"]
  }
];

export const PROJECTS = [
  {
    id: "eternittag-paa-sjaelland",
    slug: "eternittag-paa-sjaelland",
    category: "Tag",
    title: "Eternittag på Sjælland",
    m2_price: "990 kr. pr. m2",
    roof_type: "B7 Eternittag",
    location: "Sjælland Tappernøje",
    image: "/_assets/01_0e9d7fdf.jpg",
    description: "For en kunde på Sjælland stod vi for at fjerne og bortskaffe det gamle betontag samt lægge nyt eternittag B7.",
    content: "For en kunde på Sjælland stod vi for at fjerne og bortskaffe det gamle betontag samt lægge nyt eternittag B7.",
    included: [
      "Nyt eternittag B7",
      "Udskiftning af gammelt betontag",
      "Opbygning af stillads",
      "Bortskaffelse af byggeaffald"
    ],
    gallery_images: [
      "/_assets/01_0e9d7fdf.jpg"
    ]
  },
  {
    id: "eternittag-i-sabro",
    slug: "eternittag-i-sabro",
    category: "Tag",
    title: "Eternittag i Sabro",
    m2_price: "Ca. 1.100 kr. inkl. moms",
    roof_type: "Eternittag",
    location: "Sabro",
    image: "/_assets/01_bde89f58.jpg",
    description: "For en kunde udførte vi udskiftning af et gammelt asbesttag med et nyt eternittag B6. Opgaven inkluderede stillads og miljømæssig bortskaffelse.",
    content: "For en kunde udførte vi udskiftning af et gammelt asbesttag med et nyt eternittag B6. Opgaven inkluderede opbygning af stillads og bortskaffelse af byggeaffald.",
    included: [
      "Nyt eternittag B6",
      "Udskiftning af gammelt asbesttag",
      "Opbygning af stillads",
      "Bortskaffelse af byggeaffald"
    ],
    gallery_images: [
      "/_assets/01_bde89f58.jpg",
      "/_assets/02_f2c81c7f.jpg"
    ]
  },
  {
    id: "nye-vinduer-i-aabyhoej",
    slug: "nye-vinduer-i-aabyhoej",
    category: "Energiløsninger",
    title: "Nye vinduer i Åbyhøj",
    m2_price: "Efter aftale",
    roof_type: "Vinduer og døre",
    location: "Åbyhøj",
    image: "/_assets/01_6c362393.jpg",
    description: "I en klassisk murermestervilla i Åbyhøj har vi udskiftet 10 vinduer. Opgaven blev udført med stillads og omfattede færdig finish både indvendigt og udvendigt.",
    content: "I en klassisk murermestervilla i Åbyhøj har vi udskiftet 10 vinduer. Opgaven blev udført med stillads og omfattede færdig finish både indvendigt og udvendigt.",
    included: [
      "Udskiftning af 10 energirigtige vinduer",
      "Færdig finish indvendigt og udvendigt",
      "Stilladsopsætning",
      "Bortskaffelse af udtjente vinduer"
    ],
    gallery_images: [
      "/_assets/01_6c362393.jpg",
      "/_assets/02_adadbb2b.jpg"
    ]
  },
  {
    id: "betontag-i-skanderborg",
    slug: "betontag-i-skanderborg",
    category: "Tag",
    title: "Betontag i Skanderborg",
    m2_price: "Ca. 1320 kr. inkl. moms",
    roof_type: "Betontag",
    location: "Skanderborg",
    image: "/_assets/01.jpg",
    description: "For en kunde i Skanderborg udførte vi en komplet tagrenovering, som omfattede nyt betontag, isolering af loftet, nye vindskeder, zink tagrender og nedløb.",
    content: "For en kunde i Skanderborg udførte vi en komplet tagrenovering, som omfattede nyt betontag, isolering af loftet, nye vindskeder, zink tagrender og nedløb.",
    included: [
      "Nyt betontag",
      "Isolering af loft",
      "Nye vindskeder",
      "Zink tagrender og nedløb",
      "Opbygning af stillads & bortskaffelse af byggeaffald"
    ],
    gallery_images: [
      "/_assets/01.jpg",
      "/_assets/02.jpg"
    ]
  },
  {
    id: "betontag-i-silkeborg",
    slug: "betontag-i-silkeborg",
    category: "Tag",
    title: "Betontag i Silkeborg",
    m2_price: "Ca. 1.390 kr. inkl. moms",
    roof_type: "Betontag",
    location: "Silkeborg",
    image: "/_assets/01_daece9cc.jpg",
    description: "For en kunde i Silkeborg lagde vi et helt nyt betontag, hvor der i samme omgang blev isoleret loftrummet samt lavet helt ny underbeklædning, stern og vindskeder.",
    content: "For en kunde i Silkeborg lagde vi et helt nyt betontag, hvor der i samme omgang blev isoleret loftrummet samt lavet helt ny underbeklædning, stern og vindskeder.",
    included: [
      "Nyt betontag",
      "Isolering af loft",
      "Gangbro & Vindstop",
      "Underbeklædning, stern og vindskeder",
      "12\" zink tagrender og nedløb",
      "Opbygning af stillads & bortskaffelse af byggeaffald"
    ],
    gallery_images: [
      "/_assets/01_daece9cc.jpg",
      "/_assets/02_68d24935.jpg",
      "/_assets/03_f1c51239.jpg",
      "/_assets/04_ce6000da.jpg",
      "/_assets/05.jpg",
      "/_assets/06.jpg",
      "/_assets/07.jpg",
      "/_assets/08.jpg",
      "/_assets/09.jpg"
    ]
  },
  {
    id: "eternittag-i-randers",
    slug: "eternittag-i-randers",
    category: "Tag",
    title: "Eternittag i Randers",
    m2_price: "Ca. 852 kr. inkl. moms.",
    roof_type: "Eternittag",
    location: "Randers",
    image: "/_assets/01_3a438c12.jpg",
    description: "En kunde i Randers fik lagt et nyt flot eternittag, der er både flot, miljøvenlig og vedligeholdsfrit. Dansk Tagbyg stod desuden for isolering af loftrummet og vindstop.",
    content: "En kunde i Randers fik lagt et nyt flot eternittag, der er både flot, miljøvenlig og vedligeholdsfrit. Dansk Tagbyg stod desuden for isolering af loftrummet og vindstop.",
    included: [
      "Nyt B7 eternittag",
      "Isolering af loft",
      "Vindstop",
      "Opbygning af stillads & bortskaffelse af byggeaffald"
    ],
    gallery_images: [
      "/_assets/01_3a438c12.jpg",
      "/_assets/02_cb7f0565.jpg",
      "/_assets/03.jpg",
      "/_assets/04.jpg"
    ]
  },
  {
    id: "tegltag-i-skanderborg",
    slug: "tegltag-i-skanderborg",
    category: "Tag",
    title: "Tegltag i Skanderborg",
    m2_price: "Ca. 1.737 kr inkl. moms.",
    roof_type: "Tegltag",
    location: "Skanderborg",
    image: "/_assets/01_7a8ebc84.jpg",
    description: "Dansk Tagbyg stod for at lægge et helt nyt tegltag på en større bygning i Skanderborg, der trængte til en kærlig hånd.",
    content: "Dansk Tagbyg stod for at lægge et helt nyt tegltag på en større bygning i Skanderborg, der trængte til en kærlig hånd.",
    included: [
      "Nyt tegltag",
      "Opbygning af stillads",
      "Vindstop",
      "Zink tagrender og nedløb"
    ],
    gallery_images: [
      "/_assets/01_7a8ebc84.jpg",
      "/_assets/02_e21c1837.jpg",
      "/_assets/03_fe1f7b42.jpg"
    ]
  },
  {
    id: "decratag-i-harlev",
    slug: "decratag-i-harlev",
    category: "Tag",
    title: "Decratag i Harlev",
    m2_price: "Ca. 1.050 kr inkl. moms.",
    roof_type: "Decratag",
    location: "Harlev",
    image: "/_assets/01_b189040d.jpg",
    description: "For en kunde i Harlev leverede Dansk Tagbyg et nyt Decra ståltag ovenpå det eksisterende tag. Vi isolerede samtidig loftet, inkl. isoleringstop og gangbro.",
    content: "For en kunde i Harlev leverede Dansk Tagbyg et nyt Decra ståltag ovenpå det eksisterende tag. Vi isolerede samtidig loftet, inkl. isoleringstop og gangbro.",
    included: [
      "Nyt Decra ståltag ovenpå eksisterende",
      "Opbygning af stillads & bortskaffelse af byggeaffald",
      "Ny stern og vindskeder",
      "Zink tagrender og nedløb",
      "Isolering på loft + isoleringstop og gangbro"
    ],
    gallery_images: [
      "/_assets/01_b189040d.jpg"
    ]
  },
  {
    id: "P10",
    slug: "P10",
    category: "Tag",
    title: "Nyt Let beton tag silkeborg",
    m2_price: "Ca. 1992 kr. Inkl. Moms",
    roof_type: "Let beton tag B&C25",
    location: "Silkeborg",
    image: "/_assets/17754.jpg",
    description: "Endnu en flot tagrenovering udført af Dansk Tagbyg! Her har vi givet huset en komplet tagrenovering med fokus på både kvalitet, holdbarhed og et flot resultat.",
    content: "<p>🏠 Endnu en flot tagrenovering udført af Dansk Tagbyg!</p><p>Her har vi givet huset en komplet tagrenovering med fokus på både kvalitet, holdbarhed og et flot resultat.</p><ul><li>Fjernelse og sikker håndtering af det gamle asbesttag</li><li>Nyt B&amp;C 25 letbetontag</li><li>Efterisolering af loftet</li><li>Nye gavle og sternbrædder</li><li>Nye zinktagrender</li><li>Ny nedfældet skotrende</li></ul><p>Resultatet er et flot og tidløst tag, hvor både udseende og funktionalitet er tænkt ind i løsningen.</p>",
    included: [
      "Fjernelse og sikker håndtering af det gamle asbesttag",
      "Nyt B&C 25 letbetontag",
      "Efterisolering af loftet",
      "Nye gavle og sternbrædder",
      "Nye zinktagrender",
      "Ny nedfældet skotrende"
    ],
    gallery_images: [
      "/_assets/17754.jpg",
      "/_assets/17760.jpg",
      "/_assets/17753.jpg",
      "/_assets/17752.jpg",
      "/_assets/17750.jpg",
      "/_assets/17755.jpg",
      "/_assets/17752_dd6968e8.jpg"
    ]
  }
];

export const REVIEWS = [
  {
    id: "galten",
    author: "Kunde i Galten",
    location: "Galten",
    rating: 5,
    date: "2025-02-10",
    quote: "Aftaler og pris er overholdt. Nem at komme i kontakt med under hele forløbet. Der har været god kommunikation med håndværkerne og de har udført et yderst professionelt stykke arbejde som vi vil nyde i årene fremover. Finish og oprydning kendetegner firmaet."
  },
  {
    id: "brabrand",
    author: "Kunde i Brabrand",
    location: "Brabrand",
    rating: 5,
    date: "2025-01-22",
    quote: "Allerede ved første besøg var det en god oplevelse, god forståelse for vores ønsker og konstruktive forslag til løsninger vi ikke havde tænkt på... God og hurtig kommunikation fra modtagelse af tilbud til accept."
  },
  {
    id: "langaa",
    author: "Kunde i Langå",
    location: "Langå",
    rating: 5,
    date: "2024-11-15",
    quote: "Midtjyllands allerbedste priser, til den bedste kvalitet. Lasse er ærlig, imødekommende og det er hurtigt tydeligt, at han ved, hvad han taler om. Vi kunne ikke være mere tilfreds med slutresultatet."
  },
  {
    id: "ringsted",
    author: "Kunde i Ringsted",
    location: "Ringsted",
    rating: 5,
    date: "2024-10-04",
    quote: "Jeg fik udskiftet mit tag, tagrender, vindskeder og isat et nyt Velux vindue på blot fem dage. Jeg ønskede ikke at risikere et hus pakket ind i stilladser i månedsvis, fordi en evt. anden håndværker også havde andre opgaver ind i mellem."
  },
  {
    id: "roskilde",
    author: "Kunde i Roskilde",
    location: "Roskilde",
    rating: 5,
    date: "2024-09-18",
    quote: "Vi havde en rigtig god fornemmelse da Steffen var ude at give tilbud, og det holdt stik da Lasse og hans hold kom og skiftede vores tag på kun 5 dage. De var søde og imødekomne og meget effektive. Og så ryddede de pænt op efter sig hver dag."
  },
  {
    id: "aarhus",
    author: "Kunde i Aarhus",
    location: "Aarhus",
    rating: 5,
    date: "2024-08-30",
    quote: "Fik udskiftet et gammelt tegltag og sat nye Velux vinduer i. Behagelige mennesker at omgås hele vejen igennem, hjælpsomme med råd og vejledning fra start til slut. Tidsplanen blev overholdt, faktisk blev der startet en uge før oprindeligt planlagt."
  }
];

export const PRICING_MATRIX = {
  roofTypes: [
    {
      id: "tegltag",
      name: "Tegltag",
      pricePerM2: 1457.50,
      unit: "m²",
      description: "Klassisk ægte tegl med over 100 års levetid",
      image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/tegl_75df1058.jpeg"
    },
    {
      id: "glaseret-tegl",
      name: "Glaseret tegltag",
      pricePerM2: 1644.50,
      unit: "m²",
      description: "Eksklusiv blank overflade, smudsafvisende og elegant",
      image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/glaseret_75330725.jpeg"
    },
    {
      id: "decra",
      name: "Decra",
      pricePerM2: 763.00,
      unit: "m²",
      description: "Stærk stålkerne med stengranulat og 30 års produktgaranti",
      image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/decra_91019e99.jpeg"
    },
    {
      id: "beton",
      name: "Betontag",
      pricePerM2: 1868.75,
      unit: "m²",
      description: "Stærkt, solidt og modstandsdygtigt betontag",
      image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/beton_887bca74.jpeg"
    },
    {
      id: "skifertag",
      name: "Skifer",
      pricePerM2: 1308.00,
      unit: "m²",
      description: "Eksklusiv og elegant tagløsning med ekstrem lang holdbarhed",
      image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/skifer_0d4706fe.jpeg"
    },
    {
      id: "eternittag",
      name: "Eternit",
      pricePerM2: 763.00,
      unit: "m²",
      description: "Vedligeholdelsesfrit og økonomisk fibercementtag",
      image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/eternit_faf7d34e.jpeg"
    }
  ],
  slopes: [
    {
      id: "12-34",
      name: "12 - 34°",
      description: "Standard taghældning",
      multiplier: 1.0,
      image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/taghaeldning-15.jpg"
    },
    {
      id: "35-50",
      name: "35 - 50°",
      description: "Stejl taghældning (+10% tillæg)",
      multiplier: 1.10,
      image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/taghaeldning-stejl-45.jpg"
    }
  ],
  angles: [
    { id: "rektangulaer", name: "Rektangulær", description: "Rektangulær tagkonstruktion", multiplier: 1.0 },
    { id: "vinkel", name: "Vinkel", description: "Vinkelhus (+30% tillæg)", multiplier: 1.30 }
  ],
  insulationOptions: [
    { id: "none", name: "Ingen efterisolering", pricePerM2: 0 },
    { id: "standard_100", name: "Efterisolering +100 mm", pricePerM2: 180 },
    { id: "full_200", name: "Komplet efterisolering +200-300 mm (Lavenergi)", pricePerM2: 290 }
  ],
  extraOptions: [
    { id: "gutters", name: "Nye zink tagrender & nedløb", basePrice: 12000 },
    { id: "old_removal", name: "Aftagning & bortskaffelse af gammelt tag", pricePerM2: 160 },
    { id: "asbestos_removal", name: "Autoriseret nedtagning af asbesttag", pricePerM2: 240 },
    { id: "skylights", name: "Velux ovenlysvindue (pr. stk)", fixedPricePerUnit: 14500, count: 0 }
  ]
};
